import { writable } from "svelte/store";

const { subscribe, set, update } = writable({
    pw: null,
    adminUser: null,
    adminPw: null,
} as { pw: string | null, adminUser: string | null, adminPw: string | null });

export const store = {
    subscribe,
    set,
    update
};